'use strict';
exports.__esModule = true;
exports.getSlotContext = void 0;
var react_1 = require('react');
// Slots are nested, so higher-level Slots can contain lower-level Slots.
// Multiple Plugs can be consumed by the same Slot, and the reference to the
// current Plug is is passed down through the Slot context. A different context
// is created for each Slot name to prevent Slots that contain other Slots from
// interfering with each other’s Plug references.
var slotContexts = {};
function getSlotContext(slotName) {
  if (!slotContexts[slotName])
    slotContexts[slotName] = react_1.createContext(undefined);
  return slotContexts[slotName];
}
exports.getSlotContext = getSlotContext;
